"use client";

import { Suspense } from "react";
import { useMessages } from "@/i18n/client";
import { countries, useGeo } from "@/i18n/routing";
import styles from "./GeoSelector.module.css";

const UnsuspendedGeoStatus = () => {
	const messages = useMessages();
	const { country, language } = useGeo();
	const realCountry = countries.find((c) => c.country === country);
	const languages = messages.languages as unknown as Record<string, string> | undefined;
	const languageName = languages?.[language] ?? language;

	return (
		<span className={styles.geoStatus}>
			{languageName} / ({realCountry?.currency})
		</span>
	);
};

export const GeoStatus: typeof UnsuspendedGeoStatus = () => {
	return (
		<Suspense>
			<UnsuspendedGeoStatus />
		</Suspense>
	);
};
